module.exports = __webpack_public_path__ + "static/interstate-light-cc8aacc7484646107cd4012471b0e93d.otf";